<template>
    <v-container
      fluid>
        <v-row
            align="center"
            justify="center"
            class="dashboard-links"
        >
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/calendar"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-calendar-month-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Job's Calendar</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/custom_calendar"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-calendar-month-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Pre-Construction Calendar</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/leads"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-folder-plus-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Leads</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/customers"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-account-multiple-check
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Customers</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole != 'workorder'"
            >
                <v-card
                    light
                    to="/jobs"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-handshake-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Jobs</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole != 'workorder' && userRole != 'punchlist'"
            >
                <v-card
                    light
                    to="/deposits"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-credit-card-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Deposits</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole != 'workorder' && userRole != 'punchlist'"
            >
                <v-card
                    light
                    to="/itissues"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-email-alert
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Construction Punchlist</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole != 'punchlist'"
            >
                <v-card
                    light
                    to="/workorders"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-email-alert
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Workorders</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole != 'workorder' && userRole != 'punchlist'"
            >
                <v-card
                    light
                    to="/serviceissues"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-email-alert
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Service Punchlist</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/teams"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-account-multiple-plus-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Teams</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-account-tie-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Vendors</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/reports"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-chart-line
                        </v-icon>                        
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Reports</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/newsms"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-message-processing
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Send SMS</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    to="/users"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-account-supervisor-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Users</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="4"
                v-if="userRole == 'admin' || userRole == 'foreman'"
            >
                <v-card
                    light
                    outlined
                    to="/settings"
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-cog-transfer
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Settings</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import authmixin from '../mixin/auth.js'

    export default {
        mixins: [authmixin],
        data: () => ({

        }),
        computed: {
        },
        created() {
            this.$store.commit('data/SET_CUSTOMERS', [])
            this.$store.commit('data/SET_JOBS', [])
            this.$store.commit('data/SET_WORKORDERS', [])
        }
    }
</script>
<style lang="sass">
.v-content
    background: #003a6f

.dashboard-links
    padding: 4px
    
    .col-6
        padding: 4px

        .v-card 
            min-height: calc((100vh - 96px)/3)
            display: flex
            flex-wrap: wrap
            align-content: center
            justify-content: center

.v-application 
    .headline
        font-family: 'Pyxel'!important
        font-size: 1.5em!important
</style>